module.exports = __webpack_public_path__ + "static/media/sidus.63de34dd.png";